import React, { useState, useEffect, useMemo, useCallback } from "react";
import Select from "react-select";

function IntentsFilter({ filters, setFilters, intents }) {
  const dateOptions = useMemo(
    () => [
      { value: "today", label: "Today" },
      { value: "thisWeek", label: "This Week" },
      { value: "thisMonth", label: "This Month" },
      { value: "thisYear", label: "This Year" },
      { value: "all", label: "All" },
      { value: "custom", label: "Custom" },
    ],
    []
  );

  const handleChange = useCallback(
    (selectedOptions, { name }) => {
      setFilters(
        (
          prev = {
            excludeWeekends: true,
            dateRange: { value: "today", label: "Today" },
          }
        ) => {
          const newFilters = {
            ...prev,
            [name]: selectedOptions,
          };
          return newFilters;
        }
      );
    },
    [setFilters]
  );

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      height: "auto",
    }),
    option: (provided) => ({
      ...provided,
      display: "flex",
      justifyContent: "space-between",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e2e8f0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      flexWrap: "nowrap",
      overflowX: "auto",
      maxHeight: "100px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000, // Increase this value as needed
    })
  };

  const formattedIntents = useMemo(() => {
    console.log("INTENTS", intents)
    if(intents) {
      intents.map((intent) => ({
        value: intent.intentName,
        label: intent.intentName,
        count: intent.totalCalls,
      }));
    }
    
  }, [intents]);

  const formattedCategories = useMemo(() => {
    if(intents) {
      const categoryCount = intents.reduce((acc, obj) => {
        const category = obj.category;
        acc[category] = (acc[category] || 0) + 1;
        return acc;
      }, {});
  
      return Object.entries(categoryCount).map(([category, count]) => ({
        value: category,
        label: category,
        count: count,
      }));
    } else {
      return [];
    }
    
  }, [intents]);

  return (
    <div className="mb-4 p-4 bg-gray-100 rounded-lg">
      <div className="flex space-x-8 mb-1 ml-5 mr-5">
        
        <div className="flex-1 relative">
          <Select
            name="dateRange"
            value={filters.dateRange}
            onChange={(option) => handleChange(option, { name: "dateRange" })}
            options={dateOptions}
            styles={customStyles}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: 'rgb(129 140 248)',
              },
            })}
          />
        </div>
        
      </div>
    </div>
  );
}

export default IntentsFilter;
